import { useState } from 'react';
import { Modal } from 'src/components';
import { ModalProps } from 'src/components/Modal/modal.types';

type State = Omit<ModalProps, 'open'>;
export const useModal = () => {
  const [state, setState] = useState<State | null>(null);
  const [open, setOpen] = useState(false);

  const confirm = (state: State) => {
    setState(state);
    setOpen(true);
  };

  const update = (state: Partial<State>) => {
    setState((prev) => {
      if (!prev) return null;
      return { ...prev, ...state };
    });
  };

  const destroy = () => {
    setOpen(false);
    setState(null);
  };

  const context = (
    <Modal open={open} onClose={destroy} {...state}>
      {state?.children}
    </Modal>
  );

  return { confirm, update, destroy, context };
};
